import { FrontendEnvironment } from '../../../libraries/branch-tooling-next/Environment/FrontendEnvironment';
import type { IFrontendEnvironment } from '../../../libraries/branch-tooling-next/Environment/IFrontendEnvironment';

const BLACK_LIST: Set<string> = new Set(['dashboard-release.stage.branch.io']);

export class ConsoleSuppressor {
  private console: Console;

  private window: Window;

  private frontendEnvironment: IFrontendEnvironment;

  constructor(windowElement, console) {
    this.console = console;
    this.window = windowElement;
    this.frontendEnvironment = new FrontendEnvironment(windowElement);
  }

  isWhiteListed() {
    return !this.frontendEnvironment.isProduction();
  }

  isBlackListed() {
    const { host } = this.window.location;
    return BLACK_LIST.has(host);
  }

  hide() {
    this.console.warn = () => {};
    // @ts-ignore
    this.console.disableYellowBox = true;
  }

  hideWarnings() {
    if (this.isBlackListed()) {
      this.hide();
      return;
    }

    if (!this.isWhiteListed()) {
      this.hide();
    }
  }
}
